import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IFaIcon } from './fa.icon.interface';

@Component({
    selector: 'mlp-ng-fa-icon',
    templateUrl: './fa.icon.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class FaIconSharedComponent {
    @Input() icon: IFaIcon;
}
